<template>
    <div class="SalesDaily">
        <div class="top-wrapper">
            <div class="select-wrapper">
                <div class="select-item">
                    <div @click="startTimePicker = true">
                        <span>{{ startTimeValue }}</span>
                        <i class="iconfont iconxiala"></i>
                    </div>
                </div>
                <div
                    class="select-item"
                    @click="showPicker = true"
                >
                    <span>{{ StationName }}</span>
                    <i class="iconfont iconxiala"></i>
                </div>
            </div>
            <div class="statistics-head">
                <van-swipe
                    class="my-swipe"
                    :autoplay="8000"
                    indicator-color="white"
                >
                    <van-swipe-item>
                        <div>
                            <h5>
                                <span>总任务(个)</span>
                            </h5>
                            <p>{{ taskData.rws }}</p>
                        </div>
                        <div>
                            <h5>
                                <span>总派单(个)</span>
                            </h5>
                            <p>{{ taskData.pds }}</p>
                        </div>
                        <div v-if="$store.state.versionMark == 2">
                            <h5>
                                <span>总金额(万元)</span>
                            </h5>
                            <p>{{ taskData.zje }}</p>
                        </div>
                    </van-swipe-item>
                    <van-swipe-item>
                        <div>
                            <template v-if="taskData.fhfl > 10000">
                                <h5>
                                    <span>发货方量(万方)</span>
                                </h5>
                                <p>{{ numberConvert(taskData.fhfl) }}</p>
                            </template>
                            <template v-else>
                                <h5>
                                    <span>发货方量(方)</span>
                                </h5>
                                <p>{{ taskData.fhfl }}</p>
                            </template>
                        </div>
                        <div>
                            <template v-if="taskData.qsfl > 10000">
                                <h5>
                                    <span>签收方量(万方)</span>
                                </h5>
                                <p>{{ numberConvert(taskData.qsfl) }}</p>
                            </template>
                            <template v-else>
                                <h5>
                                    <span>签收方量(方)</span>
                                </h5>
                                <p>{{ taskData.qsfl }}</p>
                            </template>
                        </div>
                        <div>
                            <template v-if="taskData.hdhqsfl > 10000">
                                <h5>
                                    <span>核算后签收方量(万方)</span>
                                </h5>
                                <p>{{ numberConvert(taskData.hdhqsfl) }}</p>
                            </template>
                            <template v-else>
                                <h5>
                                    <span>核算后签收方量(方)</span>
                                </h5>
                                <p>{{ taskData.hdhqsfl }}</p>
                            </template>
                        </div>
                        <div>
                            <template v-if="taskData.yljfl > 10000">
                                <h5>
                                    <span>当月累计方量(万方)</span>
                                </h5>
                                <p>{{ numberConvert(taskData.yljfl) }}</p>
                            </template>
                            <template v-else>
                                <h5>
                                    <span>当月累计方量(方)</span>
                                </h5>
                                <p>{{ taskData.yljfl }}</p>
                            </template>
                        </div>
                        <div>
                            <template v-if="taskData.nljfl">
                                <h5>
                                    <span>本年累计方量(万方)</span>
                                </h5>
                                <p>{{ numberConvert(taskData.nljfl) }}</p>
                            </template>
                            <template v-else>
                                <h5>
                                    <span>本年累计方量(方)</span>
                                </h5>
                                <p>{{ taskData.nljfl }}</p>
                            </template>
                        </div>
                    </van-swipe-item>
                    <van-swipe-item v-if="$store.state.versionMark == 2">
                        <div>
                            <h5>
                                <span>当日平均砼单价<br>(元/方)</span>
                            </h5>
                            <p>{{ taskData.rpjtdj }}</p>
                        </div>
                        <div>
                            <h5>
                                <span>当月平均砼单价<br>(元/方)</span>
                            </h5>
                            <p>{{ taskData.ypjtdj }}</p>
                        </div>
                        <div>
                            <h5>
                                <span>本年平均砼单价<br>(元/方)</span>
                            </h5>
                            <p>{{ taskData.npjtdj }}</p>
                        </div>
                    </van-swipe-item>
                    <van-swipe-item v-if="$store.state.versionMark == 2">
                        <div>
                            <h5>
                                <span>累计砼金额(万元)</span>
                            </h5>
                            <p>{{ taskData.ljtje }}</p>
                        </div>
                        <div>
                            <h5>
                                <span>核算后累计砼<br>金额(万元)</span>
                            </h5>
                            <p>{{ taskData.hshljtje }}</p>
                        </div>
                        <div>
                            <h5>
                                <span>当月累计砼<br>金额(万元)</span>
                            </h5>
                            <p>{{ taskData.yljtje }}</p>
                        </div>
                        <div>
                            <h5>
                                <span>本年累计砼<br>金额(万元)</span>
                            </h5>
                            <p>{{ taskData.nljtje }}</p>
                        </div>
                    </van-swipe-item>
                </van-swipe>
            </div>
        </div>
        <div class="charts">
            <div class="chart_header">
                <p>砼方量</p>
                <van-tabs
                    type="card"
                    color="#3495FB"
                    v-model="volumeActive"
                    @click="tabSelect('volume')"
                >
                    <template v-for="(item,index) in tabData">
                        <van-tab :key="index" :title="item.name" :disabled="item.disabled"></van-tab>
                    </template>
                </van-tabs>
            </div>
            <div id="volume" class="my-chart"></div>
        </div>
        <div class="charts" v-if="$store.state.versionMark == 2">
            <div class="chart_header">
                <p>砼金额</p>
                <van-tabs
                    type="card"
                    color="#3495FB"
                    v-model="moneyActive"
                    @click="tabSelect('money')"
                >
                    <template v-for="(item,index) in tabData">
                        <van-tab :key="index" :title="item.name" :disabled="item.disabled"></van-tab>
                    </template>
                </van-tabs>
            </div>
            <div>
            </div>
            <div id="money" class="my-chart"></div>
        </div>
        <footer>
            <button @click="openReport">
                销售日报表
            </button>
        </footer>
        <!-- 选择场站组件 -->
        <van-popup
            v-model="showPicker"
            position="bottom"
        >
            <van-picker
                show-toolbar
                :columns="columns"
                @cancel="showPicker = false"
                @confirm="onConfirm"
            ></van-picker>
        </van-popup>
        <!-- 时间控件 -->
        <van-popup
            v-model="startTimePicker"
            position="bottom"
            :overlay="true"
        >
            <van-datetime-picker
                v-model="startCurrentDate"
                type="date"
                title="选择年月日"
                @confirm="startConfirmData"
                @cancel="startTimePicker = false"
            ></van-datetime-picker>
        </van-popup>
    </div>
</template>

<script>
import {
    barChart,
    areaChart,
    lineBarChart,
} from '@/assets/js/charts';

export default {
    name: 'sales-daily',
    data() {
        return {
            startTimeValue: '', // 开始时间text
            startTimePicker: false, // 开始时间弹出层
            startCurrentDate: new Date(new Date().getTime() - 3600 * 1000 * 24), // 开始时间默认日期
            // 场站名称
            StationName: '',
            // 场站id
            StationId: '',
            // 场站数据集合
            StationData: [
                {
                    station_id: '',
                    station_name: '全部',
                },
            ],
            // 场站弹出层状态
            showPicker: false,
            // 场站可选数据集合
            columns: [],
            // 任务数据
            taskData: {
                fhfl: 0,
                hdhqsfl: 0,
                hshljtje: 0,
                ljtje: 0,
                nljfl: 0,
                nljtje: 0,
                npjtdj: 0,
                pds: 0,
                qsfl: 0,
                rpjtdj: 0,
                rws: 0,
                yljfl: 0,
                yljtje: 0,
                ypjtdj: 0,
                zje: 0,
            },
            tabData: [{
                name: '本周趋势',
                disabled: false,
            }, {
                name: '场站统计',
                disabled: false,
            }],
            // 方量默认显示
            volumeActive: 0,
            // 砼方量——周
            concreteVolume_week: {},
            // 砼方量——场站
            concreteVolume_Station: {},
            // 金额默认显示
            moneyActive: 0,
            // 砼金额——周
            concreteMoney_week: {},
            // 砼金额——场站
            concreteMoney_Station: {},
        };
    },
    created() {
        this.startTimeValue = this.formatDate(this.startCurrentDate);
    },
    watch: {
        startTimeValue(newVal) {
            if (newVal !== '') {
                if (this.StationData.length < 2) {
                    // 获取场站
                    this.getStationList();
                } else {
                    this.init();
                }
            }
        },
        StationId(newVal) {
            if (newVal !== '') {
                this.tabData[1].disabled = true;
                this.volumeActive = 0;
                this.moneyActive = 0;
            } else {
                this.tabData[1].disabled = false;
            }
            this.init();
        },
    },
    mounted() {},
    methods: {
        // 获取企业下所有场站
        getStationList() {
            let stationIds = this.$takeTokenParameters('StationIds');
            if (stationIds) {
                stationIds = stationIds.split(',');
                const stationNames = this.$takeTokenParameters('StationNames').split(',');
                const stationList = stationIds.map((id, index) => {
                    return {
                        station_id: id,
                        station_name: stationNames[index],
                    };
                });
                this.StationData.push(...stationList);
                this.columns = this.StationData.map(item => item.station_name);
                this.StationName = this.columns[0];
                this.StationId = this.StationData[0].station_id;
                this.init();
            }
        },
        // 初始化页面
        init() {
            // 获取任务数据
            this.getTaskData();

            // 初始化砼方量图表
            if (this.volumeActive === 0) {
                // 获取砼方量——周
                this.getConcreteVolume_week();
            } else {
                // 获取砼方量——场站
                this.getConcreteVolume_Station();
            }

            // 初始化砼金额图表
            if (this.moneyActive === 0) {
                // 获取砼金额——周
                this.getConcreteMoney_week();
            } else {
                // 获取砼金额——场站
                this.getConcreteMoney_Station();
            }
        },
        // 确认选择事件
        startConfirmData(val) {
            this.startTimePicker = false;
            this.startTimeValue = this.formatDate(val);
        },
        // 时间格式化
        formatDate(date) {
            date = new Date(date);
            const y = date.getFullYear();
            let m = date.getMonth() + 1;
            let d = date.getDate();
            m = m < 10 ? '0' + m : m;
            d = d < 10 ? '0' + d : d;
            return y + '-' + m + '-' + d;
        },
        // 超过10000数字转换
        numberConvert(data) {
            return Number((data / 10000).toString().match(/^\d+(?:\.\d{0,2})?/));
        },
        // 确认选择场站
        onConfirm(val, index) {
            this.showPicker = false;
            this.StationName = this.StationData[index].station_name;
            this.StationId = this.StationData[index].station_id;
        },
        // 砼方量/金额统计方式：按周统计/按场站统计
        tabSelect(type) {
            if (type === 'volume') {
                if (this.volumeActive === 0) {
                // 获取砼方量——周
                    this.getConcreteVolume_week();
                } else {
                // 获取砼方量——场站
                    this.getConcreteVolume_Station();
                }
            } else if (type === 'money') {
                if (this.moneyActive === 0) {
                // 获取砼金额——周
                    this.getConcreteMoney_week();
                } else {
                // 获取砼金额——场站
                    this.getConcreteMoney_Station();
                }
            }
        },
        // 获取任务数据
        getTaskData() {
            this.$axios
                .get(`/interfaceApi/report/salesanalysis/xsqk/tj?station_id=${this.StationId}&datetime=${this.startTimeValue}`)
                .then(res => {
                    this.taskData = res;
                })
                .catch(error => {
                    this.$toast.fail(error.ErrorCode.Message);
                });
        },
        // 砼方量——周
        getConcreteVolume_week() {
            this.$axios
                .get(`/interfaceApi/report/salesanalysis/xsqk/tfl/week?station_id=${this.StationId}&datetime=${this.startTimeValue}`)
                .then(res => {
                    const chartData = {
                        xdata: [],
                        legendData: ['发货方量', '签收方量', '核算后签收方量'],
                        selected: ['核算后签收方量'],
                        ydata: [
                            {
                                name: '发货方量',
                                color: ['rgba(85, 136, 241, 1)', 'rgba(85, 136, 241, 0.3)', 'rgba(85, 136, 241, 0)'],
                                data: [],
                            }, {
                                name: '签收方量',
                                color: ['rgba(33, 189, 204, 1)', 'rgba(33, 189, 204, 0.3)', 'rgba(33, 189, 204, 0)'],
                                data: [],
                            }, {
                                name: '核算后签收方量',
                                color: ['rgba(250, 132, 54, 1)', 'rgba(250, 132, 54, 0.3)', 'rgba(250, 132, 54, 0)'],
                                data: [],
                            },
                        ],
                    };
                    res.forEach(item => {
                        chartData.xdata.push(item.name);
                        chartData.ydata[0].data.push(item.fhfl);
                        chartData.ydata[1].data.push(item.qsfl);
                        chartData.ydata[2].data.push(item.hdhqsfl);
                    });
                    areaChart('volume', chartData);
                })
                .catch(error => {
                    this.$toast.fail(error.ErrorCode.Message);
                });
        },
        // 砼方量——场站
        getConcreteVolume_Station() {
            this.$axios
                .get(`/interfaceApi/report/salesanalysis/xsqk/tfl/cz?datetime=${this.startTimeValue}`)
                .then(res => {
                    const chartData = {
                        xdata: [],
                        legendData: ['发货方量', '核对后签收方量'],
                        ydata: [
                            {
                                name: '发货方量',
                                color: ['#EFAB54', '#FA8C47'],
                                data: [],
                            }, {
                                name: '核对后签收方量',
                                color: ['#55A7FE', '#3E79C5'],
                                data: [],
                            },
                        ],
                    };
                    res.forEach(item => {
                        chartData.xdata.push(item.name);
                        chartData.ydata[0].data.push(item.fhfl);
                        chartData.ydata[1].data.push(item.hdhqsfl);
                    });
                    barChart('volume', chartData);
                })
                .catch(error => {
                    this.$toast.fail(error.ErrorCode.Message);
                });
        },
        // 砼金额——周
        getConcreteMoney_week() {
            this.$axios
                .get(`/interfaceApi/report/salesanalysis/xsqk/tje/week?station_id=${this.StationId}&datetime=${this.startTimeValue}`)
                .then(res => {
                    const chartData = {
                        xdata: [],
                        legendData: ['累计砼金额', '核算后累计砼金额', '当日平均砼单价'],
                        grid: ['40', '60', '40', '20'],
                        yAxisName: ['(万元)', '(元)'],
                        ydata: [
                            {
                                name: '累计砼金额',
                                type: 'bar',
                                color: ['#71C6B0', '#4EA496'],
                                data: [],
                            }, {
                                name: '核算后累计砼金额',
                                type: 'bar',
                                color: ['#F2E341', '#DCC129'],
                                data: [],
                            }, {
                                name: '当日平均砼单价',
                                type: 'line',
                                color: ['#FA8436'],
                                data: [],
                            },
                        ],
                    };
                    res.forEach(item => {
                        chartData.xdata.push(item.name);
                        chartData.ydata[0].data.push(item.ljtje);
                        chartData.ydata[1].data.push(item.hshljtje);
                        chartData.ydata[2].data.push(item.rpjtdj);
                    });
                    lineBarChart('money', chartData);
                })
                .catch(error => {
                    this.$toast.fail( error.ErrorCode.Message);
                });
        },
        // 砼金额——场站
        getConcreteMoney_Station() {
            this.$axios
                .get(`/interfaceApi/report/salesanalysis/xsqk/tje/cz?datetime=${this.startTimeValue}`)
                .then(res => {
                    const chartData = {
                        xdata: [],
                        legendData: ['累计砼金额', '核对后累计砼金额'],
                        ydata: [
                            {
                                name: '累计砼金额',
                                color: ['#71C6B0', '#4EA496'],
                                data: [],
                            }, {
                                name: '核对后累计砼金额',
                                color: ['#F2E341', '#DCC129'],
                                data: [],
                            },
                        ],
                    };
                    res.forEach(item => {
                        chartData.xdata.push(item.name);
                        chartData.ydata[0].data.push(item.ljtje);
                        chartData.ydata[1].data.push(item.hshljtje);
                    });
                    barChart('money', chartData);
                })
                .catch(error => {
                    this.$toast.fail(error.ErrorCode.Message);
                });
        },
        // 打开报表
        openReport() {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'SalesReport',
            });
        },
    },
};
</script>

<style lang="stylus">
.SalesDaily
    width 100%
    height 100%
    background #F0F0F0
    .top-wrapper
        background #ffffff
        padding 10rpx
        padding-bottom 0
        .select-wrapper
            height 45rpx
            box-shadow 0px 2px 8px 0px rgba(0, 0, 0, 0.16)
            border-radius 8px
            display flex
            .select-item
                flex 1
                text-align center
                span
                    font-size 14rpx
                    font-weight 400
                    line-height 45rpx
                i
                    color #979EA7
                &:last-child
                    position relative
                    &:before
                        content ''
                        height 20rpx
                        position absolute
                        left 0
                        top 50%
                        margin-top -10rpx
                        border-left 3rpx solid #D7D7D7
                    span
                        color #3495FB
                        padding-left 20rpx
                &:first-child
                    display flex
                    div
                        flex 1
                    p
                        line-height 45rpx
                        color #979EA7
                        font-weight 600
        .statistics-head
            background #ffffff
            display flex
            margin-top 15rpx
            .my-swipe
                width 100%
                padding-bottom 33rpx
                .van-swipe__track
                    height 72rpx
                    .van-swipe-item
                        display flex
                        div
                            flex 1
                            padding 0 4rpx
                            text-align center
                            h5
                                width 100%
                                color #979EA7
                                height 40rpx
                                font-size 10rpx
                                line-height 15rpx
                                border-radius 4rpx 4rpx 0 0
                                position relative
                                span
                                    position absolute
                                    top 50%
                                    left 50%
                                    width 100%
                                    padding 0 2rpx
                                    transform translate(-50%, -50%)
                            p
                                height 32rpx
                                line-height 32rpx
                                font-size 16rpx
                                border-radius 0 0 4rpx 4rpx
                            &:nth-of-type(1)
                                h5
                                    background rgba(85, 136, 241, 0.06)
                                p
                                    color #5588F1
                                    background rgba(85, 136, 241, 0.08)
                            &:nth-of-type(2)
                                h5
                                    background rgba(33, 189, 204, 0.06)
                                p
                                    color #21BDCC
                                    background rgba(33, 189, 204, 0.08)
                            &:nth-of-type(3)
                                h5
                                    background rgba(250, 132, 54, 0.06)
                                p
                                    color #FA8436
                                    background rgba(250, 132, 54, 0.08)
                            &:nth-of-type(4)
                                h5
                                    background rgba(134, 107, 238, 0.06)
                                p
                                    color #866BEE
                                    background rgba(134, 107, 238, 0.08)
                            &:nth-of-type(5)
                                h5
                                    background rgba(255, 183, 41, 0.06)
                                p
                                    color #FFB729
                                    background rgba(255, 183, 41, 0.08)
                .van-swipe__indicators
                    .van-swipe__indicator
                        width 15rpx
                        height 3rpx
                        background #F0F0F0
                        opacity 1
                        border-radius 0
                        &:not(:last-child)
                            margin-right 17rpx
                    .van-swipe__indicator--active
                        background #E40002 !important
    .charts
        background #ffffff
        margin-top 15rpx
        padding 10rpx
        .chart_header
            height 24rpx
            margin-bottom 10rpx
            p
                font-size 16rpx
                line-height 24rpx
                color #333333
                font-weight 500
                float left
            .van-tabs__wrap
                width 124rpx
                float right
                .van-tabs__nav--card
                    height 22rpx
                    margin 0
                    .van-tab
                        font-size 12rpx
                        line-height 22rpx
        .my-chart
            height 240rpx
    footer
        height 60rpx
        text-align center
        background #F0F0F0
        button
            width 102rpx
            height 32rpx
            margin 14rpx auto
            color #fff
            font-size 14rpx
            border none
            border-radius 3rpx
            background linear-gradient(to right, #3A96FE, #40B6FF)
</style>
